import Process from "./process.js";

export default [...Process];
